import React, { useState } from 'react'
import NavbarLink from './NavbarLink/NavbarLink';
import styles from './Leftside.module.css'
import hashnode_logo from '../../Assets/Svg/hashnode.svg'

import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from 'react-router';
import {  Fade, Modal, Paper, Typography } from '@material-ui/core';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import PublicIcon from '@material-ui/icons/Public';
import SettingsIcon from '@material-ui/icons/Settings';
import AssignmentIcon from '@material-ui/icons/Assignment';
import TurnedInIcon from '@material-ui/icons/TurnedIn';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { useDispatch, useSelector } from 'react-redux';
import { deleteToken } from '../../../redux/action';
const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        overflowX: "hidden",

        margin: 0,
        padding: 0
    },
    modal: {
        // border:"1px solid red"
        
    },
   paper: {
        width: "23%",
       height: "37vw",
        border:"1px solid #e9e9e9",
       margin: "8.5% 15%",
        outline:"none"

    },
    Buttondiv: {
        display: "flex",
        width: "100%",
        paddingTop:"19px",
        paddingBottom:"0px",
        borderTop:"0.5px solid #e9e9e9",
        // borderBottom:"0.5px solid #e9e9e9"

    },
    tagdiv1: {
        marginLeft: "7px",
        color: "#6f95fc",
        paddingBottom: "13px"
    },
    imagetag: {
        display: "flex",
        padding: "15px"
    },
    tagmargin: {
        marginTop: "0",
        marginBottom: "0"
    },
    profileText: {
        marginLeft: "10px"
    },
    imagetagtype: {
        borderRadius: "50%"
    },
 
   
    writetag: {
    
        textAlign: "center",
        marginTop:"10px"
      
    }
    ,
    Button1: {
        width: "90%"
    },
    flexdiv: {
        height: "25px",
       width:"90%",
        display: "flex",
        listStyle: "none",
       marginTop: "5px",
       alignItems: "center",
        color: "grey",
    //    border:"1px solid red",
        padding: "8.9px 20px",
        paddingBottom:"10px",
      marginLeft:"-25px",
        justifyContent: "flexStart",
        borderRadius:"3px",
        '&:hover': {
            background: "#ececec",
        }
    },
   ullist: {
       borderTop: "0.5px solid #e9e9e9",
       paddingTop:"10px"
    },
    list: {
        paddingTop:"0px",
        marginLeft: "8px",
        cursor: "pointer"
   }

}));

const Leftside = () => {
    const dispatch = useDispatch()
    const loggedInUser = useSelector(state => state.loggedInUser);
    const loggedIn = useSelector(state => state.loggedIn);
    const classes = useStyles();
    const [open, setOpen] = useState(false);

    const history = useHistory();


  

    const handleOpen = () => {
        setOpen(true);
    };


    const handleClose1 = () => {
        setOpen(false);
    
    };
    const handleLogout = () => {
        dispatch(deleteToken())
        setOpen(false);
        history.push("/");
    }
    const handleProfile = () => {
        window.location.href = `/users/${loggedInUser.username}`;
        // history.push(`/users/${loggedInUser.username}`);
        setOpen(false);
    }
    return (
        <>
            <div className={styles.leftsidebar}>
                <div className={styles.upper}>
                    <a href="/">
                        <img src={hashnode_logo} alt="hashnode" height="30" />
                    </a>
                    <button onClick={() => history.push("/create")} style={{cursor:"pointer"}} className={styles.main_btn}>
                        <svg className="w-6 h-6 mr-2 fill-current" viewBox="0 0 512 512">
                            <path d="M493.255 56.236l-37.49-37.49c-24.993-24.993-65.515-24.994-90.51 0L12.838 371.162.151 485.346c-1.698 15.286 11.22 28.203 26.504 26.504l114.184-12.687 352.417-352.417c24.992-24.994 24.992-65.517-.001-90.51zM164.686 347.313c6.249 6.249 16.379 6.248 22.627 0L368 166.627l30.059 30.059L174 420.745V386h-48v-48H91.255l224.059-224.059L345.373 144 164.686 324.687c-6.249 6.248-6.249 16.378 0 22.626zm-38.539 121.285l-58.995 6.555-30.305-30.305 6.555-58.995L63.255 366H98v48h48v34.745l-19.853 19.853zm344.48-344.48l-49.941 49.941-82.745-82.745 49.941-49.941c12.505-12.505 32.748-12.507 45.255 0l37.49 37.49c12.506 12.506 12.507 32.747 0 45.255z"></path>
                        </svg>
                        <h5>WRITE</h5>
                    </button>
                    <div className={styles.mysvg}>
                        <svg viewBox="0 0 24 24"><path d="M4.5 20.3h-.4c-1.9 0-3.5-1.6-3.5-3.5V9.4c0-.3.2-.5.5-.5h6.4c.2 0 .5.2.5.5v7.4c0 2-1.6 3.5-3.5 3.5zM1.6 9.9v6.9c0 1.4 1.1 2.5 2.5 2.5h.4c1.4 0 2.5-1.1 2.5-2.5V9.9H1.6z"></path><path d="M19.9 20.3H4.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5c1.4 0 2.5-1.1 2.5-2.5V5.9 4.2c0-.3.2-.5.5-.5h15.4c.3 0 .5.2.5.5v12.6c0 2-1.6 3.5-3.5 3.5zm-13-1h13c1.4 0 2.5-1.1 2.5-2.5V4.7H8V6c0-.1 0 0 0 0v10.8c0 1-.4 1.9-1.1 2.5z"></path><g><path d="M10.7 14.5h9.5v1h-9.5zM10.7 11h9.5v1h-9.5zM10.7 7.4h9.5v1h-9.5z"></path></g></svg>
                        <h5>My Feed</h5>
                    </div>
                    <div style={{marginLeft:"5px"}} className={styles.mysvg}>
                        <svg viewBox="0 0 384 512"><path d="M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zm-22.6 22.7c2.1 2.1 3.5 4.6 4.2 7.4H256V32.5c2.8.7 5.3 2.1 7.4 4.2l83.9 83.9zM336 480H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h176v104c0 13.3 10.7 24 24 24h104v304c0 8.8-7.2 16-16 16zm-48-244v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm0 64v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm0 64v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12z"></path></svg>
                        <h5 style={{marginLeft:"8px"}}>Drafts</h5>
                    </div>



                    <NavbarLink
                        name="Explore"
                        path="M264.97 272.97c9.38-9.37 9.38-24.57 0-33.94-9.37-9.37-24.57-9.37-33.94 0-9.38 9.37-9.38 24.57 0 33.94 9.37 9.37 24.57 9.37 33.94 0zM351.44 125c-2.26 0-4.51.37-6.71 1.16l-154.9 55.85c-7.49 2.7-13.1 8.31-15.8 15.8l-55.85 154.91c-5.65 15.67 10.33 34.27 26.4 34.27 2.26 0 4.51-.37 6.71-1.16l154.9-55.85c7.49-2.7 13.1-8.31 15.8-15.8l55.85-154.9c5.64-15.67-10.33-34.28-26.4-34.28zm-58.65 175.79l-140.1 50.51 50.51-140.11 140.11-50.51-50.52 140.11zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216z"
                    />
                    <NavbarLink
                        name="Tags"
                        path="M497.941 225.941L286.059 14.059A48 48 0 00252.118 0H48C21.49 0 0 21.49 0 48v204.118a48 48 0 0014.059 33.941l211.882 211.882c18.745 18.745 49.137 18.746 67.882 0l204.118-204.118c18.745-18.745 18.745-49.137 0-67.882zm-22.627 45.255L271.196 475.314c-6.243 6.243-16.375 6.253-22.627 0L36.686 263.431A15.895 15.895 0 0132 252.117V48c0-8.822 7.178-16 16-16h204.118c4.274 0 8.292 1.664 11.314 4.686l211.882 211.882c6.238 6.239 6.238 16.39 0 22.628zM144 124c11.028 0 20 8.972 20 20s-8.972 20-20 20-20-8.972-20-20 8.972-20 20-20m0-28c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"
                    />
                    <span onClick={() => history.push("/bookmarks")}>
                    <NavbarLink
                        name="Bookmarks"
                        path="M336 0H48C21.49 0 0 21.49 0 48v464l192-112 192 112V48c0-26.51-21.49-48-48-48zm16 456.287l-160-93.333-160 93.333V48c0-8.822 7.178-16 16-16h288c8.822 0 16 7.178 16 16v408.287z"
                    />
                    </span>
                    <div className={styles.mysvg}>
                        <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="22px" height="22px">    <path d="M 9 2 C 5.1458514 2 2 5.1458514 2 9 C 2 12.854149 5.1458514 16 9 16 C 10.747998 16 12.345009 15.348024 13.574219 14.28125 L 14 14.707031 L 14 16 L 20 22 L 22 20 L 16 14 L 14.707031 14 L 14.28125 13.574219 C 15.348024 12.345009 16 10.747998 16 9 C 16 5.1458514 12.854149 2 9 2 z M 9 4 C 11.773268 4 14 6.2267316 14 9 C 14 11.773268 11.773268 14 9 14 C 6.2267316 14 4 11.773268 4 9 C 4 6.2267316 6.2267316 4 9 4 z" /></svg>
                        <h5>Search</h5>
                    </div>


                    <NavbarLink
                        name="More"
                        path="M443.5 162.6l-7.1-7.1c-4.7-4.7-12.3-4.7-17 0L224 351 28.5 155.5c-4.7-4.7-12.3-4.7-17 0l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17l211 211.1c4.7 4.7 12.3 4.7 17 0l211-211.1c4.8-4.7 4.8-12.3.1-17z"
                    />
                </div>

                <div className={styles.lower}>
                    <svg viewBox="0 0 100 100">
                        <path d="M50 23.61c-14.55 0-26.388 11.839-26.388 26.388 0 14.55 11.839 26.388 26.388 26.388 14.55 0 26.388-11.838 26.388-26.388 0-14.55-11.839-26.388-26.388-26.388zm0 45.369c-10.466 0-18.98-8.515-18.98-18.98 0-10.463 8.514-18.982 18.98-18.982 10.466 0 18.98 8.519 18.98 18.981 0 10.466-8.514 18.98-18.98 18.98zM50 18.209a3.705 3.705 0 003.704-3.704V3.704a3.704 3.704 0 00-7.407 0v10.801A3.703 3.703 0 0050 18.209zM50 81.786a3.704 3.704 0 00-3.704 3.703v10.804a3.704 3.704 0 007.408 0V85.489A3.706 3.706 0 0050 81.786zM96.296 46.295H85.495a3.704 3.704 0 000 7.407h10.801a3.704 3.704 0 000-7.407zM18.21 49.998a3.702 3.702 0 00-3.703-3.703H3.704a3.704 3.704 0 000 7.407h10.803a3.704 3.704 0 003.703-3.704zM77.716 27.52l7.636-7.64a3.704 3.704 0 000-5.236 3.701 3.701 0 00-5.236 0l-7.637 7.637a3.703 3.703 0 105.237 5.238zM22.282 72.477l-7.638 7.639a3.703 3.703 0 105.237 5.236l7.638-7.635a3.709 3.709 0 000-5.24 3.703 3.703 0 00-5.236 0zM77.718 72.48a3.705 3.705 0 00-5.24 0 3.706 3.706 0 000 5.237l7.64 7.635a3.703 3.703 0 105.236-5.236l-7.636-7.635zM22.282 27.52a3.704 3.704 0 005.237-5.24l-7.638-7.638a3.705 3.705 0 00-5.237 0 3.706 3.706 0 000 5.237l7.638 7.64z"></path>
                    </svg>
                    <svg viewBox="0 0 448 512">
                        <path d="M224 480c-17.66 0-32-14.38-32-32.03h-32c0 35.31 28.72 64.03 64 64.03s64-28.72 64-64.03h-32c0 17.65-14.34 32.03-32 32.03zm209.38-145.19c-27.96-26.62-49.34-54.48-49.34-148.91 0-79.59-63.39-144.5-144.04-152.35V16c0-8.84-7.16-16-16-16s-16 7.16-16 16v17.56C127.35 41.41 63.96 106.31 63.96 185.9c0 94.42-21.39 122.29-49.35 148.91-13.97 13.3-18.38 33.41-11.25 51.23C10.64 404.24 28.16 416 48 416h352c19.84 0 37.36-11.77 44.64-29.97 7.13-17.82 2.71-37.92-11.26-51.22zM400 384H48c-14.23 0-21.34-16.47-11.32-26.01 34.86-33.19 59.28-70.34 59.28-172.08C95.96 118.53 153.23 64 224 64c70.76 0 128.04 54.52 128.04 121.9 0 101.35 24.21 138.7 59.28 172.08C421.38 367.57 414.17 384 400 384z"></path>
                    </svg>
                    {loggedIn ? <img onClick={handleOpen}
                        src={loggedInUser.profile_pic}
                        alt="profile"
                        height="50"
                        width="50"
                    /> : null}
                </div>

            </div>
            <Modal
                aria-labelledby="spring-modal-title"
                aria-describedby="spring-modal-description"
                className={classes.modal}
                open={open}
                onClose={handleClose1}
                closeAfterTransition

                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open}>
                    <Paper className={classes.paper}>
                        <div style={{cursor:"pointer"}} onClick={handleProfile} className={classes.imagetag} >
                            <div >
                                <img className={classes.imagetagtype}
                                    src={loggedInUser.profile_pic}
                                    alt="profile"
                                    height="50"
                                    width="50"
                                />
                            </div>
                           

                            <div className={classes.profileText}>
                                <p style={{fontWeight:"600"}} className={classes.tagmargin}>{ loggedInUser.name}</p>
                                <p style={{fontSize:"13px", color:"grey"}} className={classes.tagmargin}>@{ loggedInUser.username}</p>
                            </div>
                        </div>
                        <div>

                            <div className={classes.Buttondiv}>
                                <div style={{marginLeft:"35.7px"}} className={classes.tagdiv1}>
                                <AddCircleOutlineIcon style={{color:"#92aefa"}} />
                                </div>
                                <div style={{fontWeight:"700"}} className={classes.tagdiv1}>
                                <Typography style={{cursor:"pointer"}} onClick={() => history.push("/create")}>Write New Story</Typography>
                                </div>
                                {/* <Button onClick={handleLogout} className={classes.Button1} variant="contained" color="secondary">
                                  
                                </Button> */}
                            </div>

                            {/* <div className={classes.writetag}>
                                <Typography >Hashnode.hashnodetrem.dev</Typography>

                            </div> */}

                            <div>
                                <ul className={classes.ullist}>
                                    {/* <div className={classes.flexdiv}>
                                        <PublicIcon />
                                        <li className={classes.list}>Blog Home</li>
                                    </div> */}
                                    <div className={classes.flexdiv}>
                                        <SettingsIcon />
                                        <li className={classes.list}>Blog Dashboard</li>
                                    </div>
                                    <div className={classes.flexdiv}>
                                        <AssignmentIcon />

                                        <li className={classes.list}>Blog Drafts</li>
                                    </div>
                                    {/* <div className={classes.flexdiv}>
                                        <AssignmentIcon />
                                        <li className={classes.list}>Series</li>
                                    </div> */}
                                </ul>

                            </div>
                        </div>
                        <div >
                            <ul className={classes.ullist}>
                                <div className={classes.flexdiv}>
                                    <AssignmentIcon />
                                    <li className={classes.list}>All Drafts</li>
                                </div>
                                <div className={classes.flexdiv}>
                                    <TurnedInIcon />
                                    <li className={classes.list} >Bookmarks</li>
                                </div>
                            </ul>

                        </div>
                        <div style={{borderTop:"1px solid #e9e9e9", borderBottom:"1px solid #e9e9e9"}} className={classes.account}>
                            <ul style={{ marginBottom:"0", marginTop:"0", paddingTop:"5px", paddingBottom:"8px"}}>
                                <div className={classes.flexdiv}>
                                    <AccountCircleIcon />
                                    <li onClick={() => history.push("/settings")} className={classes.list}>Account Settings</li>
                                </div>
                          </ul>
                        </div>
                        <div>
                            <ul className={classes.ullist}>
                                <div className={classes.flexdiv}>
                                    <ExitToAppIcon />
                                    <li onClick={handleLogout} className={classes.list}>Logout</li>
                                </div>
                            </ul>
                        </div>

                    </Paper>
                </Fade>
            </Modal>
        </>
    );
}

export default Leftside
